// src/services/statsApi.js (or wherever you keep these)
import apiClient, { API_URL } from "./config";

/**
 * Logs the study session time.
 * Using fetch with credentials to ensure cookies are sent.
 */
export const logStudySession = (payload) => {
  const LOG_URL = `${API_URL}/logs/review-hours`;
  const token = localStorage.getItem("jwt_token");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(LOG_URL, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
    keepalive: true,
    credentials: "include",
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Log request failed (${res.status}): ${text || res.statusText}`);
    }
    return res;
  });
};

/**
 * Fetches the aggregated study statistics for the user.
 */
export const getStudentStats = async () => {
  try {
    const response = await apiClient.get("/logs/stats");
    return response.data; // { success, data: { weeklyActivity: [{quizSeconds, readSeconds, ...}] } }
  } catch (error) {
    console.error("Failed to fetch student stats", error);
    return null;
  }
};
